import React from 'react'
import {
  Text,
} from '@usap/uicomponents'
import ReasonContainer from '../style/Reason.css'

const ReasonsList = ({ reasonLabel, reasons, fontMinHeightCss }) => (
  <ReasonContainer>
    <Text size="14px" style={fontMinHeightCss}>
      {reasonLabel || 'Return Reasons:'}
    </Text>
    <ul>
      {reasons.map(list => (
        <li key={list.id}>
          {list.label}
        </li>
      ))}
    </ul>
  </ReasonContainer>
)

export default ReasonsList
